import { createOnPreRouteUpdate } from './src/shared/gatsby/browser-utils'

export const onPreRouteUpdate = createOnPreRouteUpdate()
